import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireGroup} from '@tisa-group/models';

@Injectable({
  providedIn: 'root',
})
export class GroupService implements CrudService<UmpireGroup> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireGroup>> {
    return this.http
      .get(`/groups/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireGroup[]>> {
    return this.http
      .get('/groups', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireGroup>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireGroup>> {
    return this.http
      .patch(`/groups/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireGroup>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireGroup>> {
    return this.http
      .post(`/groups`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/groups/${id}`);
  }
}
